import type { BridgeMessageHandler } from '../message-router.js';
import { setBridgeInstalledAgentAuthEnv } from '../../agents/acp/clients/bridge-installed-agent-auth-env.js';

export const handleInstalledAgentAuthSync: BridgeMessageHandler<'installed_agent_auth_sync'> = (
  msg,
) => {
  const entries = Array.isArray(msg.entries) ? msg.entries : [];
  setBridgeInstalledAgentAuthEnv(
    entries.filter(
      (e): e is { envVar: string; token: string } =>
        e != null &&
        typeof e === 'object' &&
        typeof (e as { envVar?: unknown }).envVar === 'string' &&
        typeof (e as { token?: unknown }).token === 'string',
    ),
  );
};
